import Accordion from "bootstrap/js/dist/modal";

export default function initMultidescription() {
    const multidescriptions = document.querySelectorAll('.multidescription');

    multidescriptions.forEach(md => {
        const imageEl = md.querySelector('.multidescription__image');
        const content = md.querySelector('.multidescription__content');

        if( content.classList.contains('multidescription__content--accordion') ) {
            multidescriptionAccordion( imageEl, content );
        } else if( content.classList.contains('multidescription__content--tabs') ) {
            multidescriptionTabs( imageEl, content );
        }
    });
}

function multidescriptionAccordion(imageEl, content) {
    content.addEventListener( 'show.bs.collapse', (event) => {
        const index = event['target'].dataset.index;

        imageEl.querySelector('img.show')?.classList.remove('show');
        document.getElementById(`multidescription__image--${index}`)?.classList.add('show');
    } );
}
function multidescriptionTabs(imageEl, content) {
    content.addEventListener( 'show.bs.tab', (event) => {
        const index = event['target'].dataset.index;

        imageEl.querySelector('img.show')?.classList.remove('show');
        document.getElementById(`multidescription__image--${index}`)?.classList.add('show');
    } );
}